
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport06Grid extends Serenity.EntityGrid<IcReport06Row, any> {
        protected getColumnsKey() { return IcReport06Columns.columnsKey; }
        protected getDialogType() { return IcReport06Dialog; }
        protected getIdProperty() { return IcReport06Row.idProperty; }
        protected getInsertPermission() { return IcReport06Row.insertPermission; }
        protected getLocalTextPrefix() { return IcReport06Row.localTextPrefix; }
        protected getService() { return IcReport06Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];

            if (request?.Criteria) {
                let criteria = request.Criteria.toString().split(',');
                let key: string = criteria[0];

                let n = columns.find(n => {
                    return options.columnStyles[n]['field'] === key
                });
                if (n) {
                    key = options.columnStyles[n]['title'];
                }

                let d1 = criteria.findIndex(c => c == ">=");
                if (d1 >= 0) {
                    let v1 = criteria[d1 + 1];
                    let d2 = criteria.findIndex(c => c == "<");

                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];

                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy" + ' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy" + ' (00:00)')}`);

                    } else {
                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
                    }
                } else {
                    let d2 = criteria.findIndex(c => c == "<");
                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];
                        descriptions.push(`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
                    }
                }
            } else {
                // descriptions.push("วันที่ = ไม่ระบุ");
            }
            // console.log(request)
            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();

                let filters = Object.keys(request.EqualityFilter);

                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    // if else{
                    if (filterValue.length > 0) {
                        if (Array.isArray(filterValue)) {
                            if (quickFilter.options.lookupKey) {
                                // console.log(filterValue);
                                (filterValue as any[]).forEach(value => {
                                    var names: string[] = new Array(filterValue);
                                    for (var i = 0; i < names.length; i++) {
                                        filterValue = (names[i]);
                                        console.log(filterValue);
                                    }
                                })

                            }
                        } else {
                            filterValue
                        }
                    }
                    else {
                        filterValue = "ไม่ระบุ"
                    }
                    // }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {
                        if (filterValue != "ไม่ระบุ") {
                            descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                        }
                    } else {
                    }
                }
            }
            
            return [descriptions, gridColumns];
        }
        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["SupplName"]);
        }
        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcReport06Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานแจ้งเตือนสินค้าที่ต่ำกว่าระดับ'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "SkuCode", title: "รหัสสินค้า", cellWidth: 20, },
                1: { field: "SkuDesc", title: "ชื่อ", cellWidth: 65, overflow: 'linebreak' },
                // 2: { field: "WhsId", title: "คลัง", cellWidth: 10,  },
                // 3: { field: "WhsName", title: "ชื่อคลัง", cellWidth: 15  ,overflow: 'linebreak'},
                2: { field: "SkuEnDesc", title: "์Name", cellWidth: 65, overflow: 'linebreak' },
                3: { field: "QtyOnhand", title: "Qty", cellWidth: 15, overflow: 'linebreak' , halign: 'right'},
                // 6: { field: "ShopGroupId", title: "กลุ่มร้าน", isHidden: true},
                // 7: { field: "ShopId", title: "ร้านค้า", isHidden: true},                
                4: { field: "StkUnit", title: "หน่วย", cellWidth: 15, overflow: 'linebreak', halign: 'center' },
                5: { field: "MinStockQty", title: "Min.", cellWidth: 20, halign: 'right' },
                6: { field: "MaxStockQty", title: "Max", cellWidth: 20, halign: 'right' },

                7: { field: "BrandCode", title: "ยี่ห้อ", isHidden: true },
                8: { field: "StyleId", title: "แบบ", isHidden: true },
                9: { field: "SizeId", title: "ขนาด", isHidden: true },
                10: { field: "ColorId", title: "สี", isHidden: true },
                11: { field: "SupplId", title: "ผู้จำหน่าย", isHidden: true },
                12: { field: "SupplName", title: "ผู้จำหน่าย", cellWidth: 65},
                13: { field: "CatCode", title: "หมวดสินค้า", isHidden: true },
                14: { field: "CatName", title: "หมวดสินค้า", isHidden: true },
                15: { field: "SubCat1Code", title: "หมวดสินค้า-2", isHidden: true },
                16: { field: "SubCat1Name", title: "หมวดสินค้า-2", isHidden: true },
                17: { field: "SubCat2Code", title: "หมวดสินค้า-3", isHidden: true },
                18: { field: "SubCat2Name", title: "หมวดสินค้า-3", isHidden: true },
                19: { field: "TasteId", title: "กลิ่น/รส", isHidden: true },
                20: { field: "MatTypeId", title: "วัสดุที่ใช้", isHidden: true },
                21: { field: "ConsignFg", title: "สินค้าฝากขาย?", isHidden: true },
                22: { field: "PurLeadTime", title: "ระยะเวลาสินค้าเข้า", cellWidth: 20, halign: 'right' },

               
                

            }

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     // pageSize:{width:210,height:297},
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            return buttons;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true;

            // opt.showFooterRow = true;
            return opt;
        }

        // protected createSlickGrid() {
        //     var grid = super.createSlickGrid();


        //     grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

        //     this.view.setSummaryOptions({
        //         aggregators: [
        //             new Slick.Aggregators.Sum('QtyOnHand'),
        //             new Slick.Aggregators.Sum('StockCostValue')

        //         ]
        //     });
        //     return grid;
        // }
    }
}